export default function setCartItemsImagesFromProducts(cartItems, products) {
  return cartItems.map((item) => {
    if (!item.image) {
      const matchingProduct = products.find((product) => product.id === item.productId)
      return { ...matchingProduct, ...item }
    }
    return item
  })
}